
/* 
    Función que crea un FileURL a partir de una imagen BLOB

    Entrada:
        - binaryString
        - tipo
        - setOpen. Abre mensaje error

    Salida:
        - FileURL
*/
const createFileURL = (binaryString, offTip, setOpen) => {
    // Decode data.data(byte[]). NECESSARY to create Blob
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    // Create a BLOB
    const file = new Blob(
        [bytes],
        { type: 
              offTip.toUpperCase() == ".PDF" ? "application/pdf" 
            : offTip.toUpperCase() == ".PNG" ? "image/png"
            : offTip.toUpperCase() == ".JPG" ? "image/jpg"
            : offTip.toUpperCase() == ".JPEG" ? "image/jpeg"
            : offTip.toUpperCase() == ".TXT" ? "text/plain"
            : offTip.toUpperCase() == ".HTML" ? "text/html"
            : offTip.toUpperCase() == ".ZIP" ? "application/zip"
            : offTip.toUpperCase() == ".DOC" ? "application/msword"
            : offTip.toUpperCase() == ".DOCX" ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            : offTip.toUpperCase() == ".XLS" ? "application/vnd.ms-excel"
            : offTip.toUpperCase() == ".XLSX" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : offTip.toUpperCase() == ".BAK" ? "application/x-bak"
            : offTip.toUpperCase() === ".CSV" ? "text/csv"
            : offTip.toUpperCase() === ".XML" ? "application/xml"
            : offTip.toUpperCase() === ".DAT" ? "application/octet-stream"
            : offTip.toUpperCase() === ".SQL" ? "application/sql"
            : (setOpen(true), "application/pdf")
        }
    );

    // Create a fileURL with preview BLOB
    return URL.createObjectURL(file);
}

export default createFileURL;